function AboutPage() {
  return (
    <div className="mx-auto max-w-lg px-4 py-12 sm:px-8">
      <h1 className="ui-page-title">About Builders</h1>
      <p className="ui-muted mt-4 max-w-prose">
        A focused workspace for your pipeline—projects, team, and vendors in one place.
      </p>
      <p className="ui-footnote mt-6 text-left">Version preview · Builders</p>
    </div>
  );
}

export default AboutPage;
